<template>
    <div class="contact-footer-text">
      <p>THE WASHINGTON-MCLAUGHLIN ADULT DAY CARE CENTER is a non-profit, tax-exempt organization. WMADCC does not practice discrimination based upon race, color, national origin, disability, sex or religion in the admissions of clients or the employment of faculty and administrative staff.</p>
      <p>Individuals with disabilities may call the Maryland Relay System 1-800-735-2258 and ask them to call 301-892-2717.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactFooter'
  }
  </script>
  
  <style scoped>

/* for desktop */
@media (min-width:701px) {
  
  .contact-footer-text {
    display: block;
    overflow-wrap: break-word;
    text-align: left;
    height: 10vh;
    margin-top: 6vh;
    margin-left: 4vw;
    margin-right: 2vw;
  }
}


/* for Phone */
@media (max-width:700px) {

  .contact-footer-text {
    text-align: left;
    font-size: 3vw;
    line-height: 3vw;
    justify-content: top left;
    margin-top: 2rem;
  }
}
  </style>